export default "__VITE_ASSET__D3CtVaK3__"